import script from "./DeleteVue.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeleteVue.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__